import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../../../lib/axios';
import { CASES_API_URL } from '../../../config/env';

export const useTopContributors = () => {
  return useQuery({
    queryKey: ['top-contributors'],
    queryFn: async () => {
      const response = await axiosInstance.get(`${CASES_API_URL}/top-contributors`);
      return response.data;
    },
  });
};
